export const Logo = () => {
  return (
    <svg className="w-headerLogoW h-headerLogoH" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M67.2417 2.99509H63.5403V7.36341H60.3828V10.861H63.5403V19.8703C63.5403 21.9357 65.2144 23.6098 67.2798 23.6098H71.5133V20.0741H67.2417V10.8977H71.5133V7.36195H67.2417V2.99362V2.99509Z"
        fill="currentColor"
      />
      <path
        d="M11.7388 20.2031C7.33674 20.2031 4.00186 16.6351 4.00186 11.9663C4.00186 7.29747 7.33674 3.79548 11.7388 3.79548C14.8406 3.79548 17.5085 5.6293 18.2414 8.26348H22.576C21.8094 3.46272 17.0746 -0.0055542 11.7388 -0.0055542C5.06902 -0.0055542 0 5.16314 0 11.9663C0 18.7695 5.06902 24.0056 11.7388 24.0056C17.2417 24.0056 21.7097 20.5036 22.6435 15.4346H18.2751C17.5745 18.2696 14.9066 20.2031 11.7388 20.2031Z"
        fill="currentColor"
      />
      <path
        d="M32.8424 7.03068C28.0402 7.03068 24.3711 10.6983 24.3711 15.5343C24.3711 20.3702 28.0402 24.0056 32.8424 24.0056C37.6447 24.0056 41.2786 20.3365 41.2786 15.5343C41.2786 10.732 37.5772 7.03068 32.8424 7.03068ZM32.8424 20.4362C30.1071 20.4362 27.9728 18.3018 27.9728 15.5343C27.9728 12.7667 30.1071 10.5649 32.8424 10.5649C35.5778 10.5649 37.6769 12.733 37.6769 15.5343C37.6769 18.3356 35.5103 20.4362 32.8424 20.4362Z"
        fill="currentColor"
      />
      <path
        d="M51.2232 7.03068C46.7215 7.03068 43.5859 10.2322 43.5859 14.901V23.6714H47.321V14.901C47.321 12.2668 48.8543 10.5986 51.2232 10.5986C53.592 10.5986 55.1254 12.2668 55.1254 14.901V23.6714H58.8267V14.901C58.8267 10.2322 55.7249 7.03068 51.2232 7.03068Z"
        fill="currentColor"
      />
      <path
        d="M81.6549 7.03068C76.8527 7.03068 73.1836 10.6983 73.1836 15.5343C73.1836 20.3702 76.8527 24.0056 81.6549 24.0056C86.4571 24.0056 90.0911 20.3365 90.0911 15.5343C90.0911 10.732 86.3897 7.03068 81.6549 7.03068ZM81.6549 20.4362C78.9196 20.4362 76.7853 18.3018 76.7853 15.5343C76.7853 12.7667 78.9196 10.5649 81.6549 10.5649C84.3903 10.5649 86.4894 12.733 86.4894 15.5343C86.4894 18.3356 84.3228 20.4362 81.6549 20.4362Z"
        fill="currentColor"
      />
      <path
        d="M104.012 16.1353C104.012 18.7695 102.445 20.4376 100.11 20.4376C97.7747 20.4376 96.2077 18.7695 96.2077 16.1353V7.3649H92.4727V16.1353C92.4727 20.8041 95.6067 24.0056 100.11 24.0056C104.613 24.0056 107.713 20.8041 107.713 16.1353V7.3649H104.012V16.1353Z"
        fill="currentColor"
      />
      <path
        d="M113.889 7.3649C112.108 7.3649 110.664 8.8088 110.664 10.5898V23.6714H114.365V10.9006H120.002V7.36637H113.889V7.3649Z"
        fill="currentColor"
      />
    </svg>
  )
}
